// Ads Registration is available in Lao only.
export const adsRegistrationText = {
  title: 'ໂຄສະນາຕິດລົດ',
  description: 'ເຈົ້າຍັງບໍ່ທັນໄດ້ລົງທະບຽນເຂົ້າຮ່ວມການຕິດໂຄສະນາໃສ່ລົດ ເພື່ອສ້າງລາຍໄດ້ເສີມ. ',
  interestOnly: 'ຖ້າຄົນຂັບສົນໃຈ ຢາກເຂົ້າຮ່ວມຕິດສະຕິກເກີ ກະລຸນາກົດປຸ່ມ ສົນໃຈລົງທະທຽນທາງລຸ່ມນີ້ ເພື່ອເຂົ້າຄິວ ',
  // noGuarantee: 'ການລົງທະບຽນບໍ່ໄດ້ຮັບປະກັນວ່າທ່ານຈະໄດ້ຮັບຄັດເລືອກ.',
  // contact: 'LOCA ຈະຕິດຕໍ່ຄົນຂັບທີ່ໄດ້ຮັບຄັດເລືອກ ເມື່ອມີໂອກາດຕິດໂຄສະນາ.',
  contact: 'ໄວໆນີ້ ໂລກ້າ ຈະເປີດບໍລິການໂຄສະນາ ເພື່ອໃຫ້ຄົນຂັບມີລາຍໄດ້ໃນການຕິດສະຕິກເກີ ເຖິງ 3,000,000ກີບ ຕໍ່ເດືອນ.',
  register: 'ສົນໃຈລົງທະບຽນຕອນນີ້',
  submitting: 'ກຳລັງລົງທະບຽນ…',
  loading: 'ກຳລັງໂຫຼດສະຖານະການລົງທະບຽນ…',
  registered: 'ລົງທະບຽນສໍາເລັດແລ້ວ',
  registeredTitle: 'ໂຄງການໂຄສະນາ LOCA',
  registeredSubtitle: 'ລົງທະບຽນເຂົ້າຮ່ວມ',
  additionalInfo: 'ຂໍ້ມູນເພີ່ມເຕີມ',
  registrationNotice: 'ການລົງທະບຽນນີ້ເປັນການສະແດງຄວາມສົນໃຈເທົ່ານັ້ນ ບໍ່ແມ່ນການຢືນຢັນວ່າທ່ານໄດ້ຮັບເລືອກເຂົ້າແຄມເປນ.',
  backHome: 'ກັບໜ້າຫຼັກ',
  thankYou: 'ຂໍຂອບໃຈທີ່ສົນໃຈໃນການຕິດໂຄສະນາເພື່ອຮັບລາຍໄດ້ເສີມ ກັບ ໂລກ້າ',
  confirmation: 'ພວກເຮົາຈະຮ່ວມຮວມລາຍຊື່ ແລະ ຕິດຕໍ່ກັບເມື່ອມີລູກຄ້າສົນໃຈລົງໂຄສະນາກັບເຈົ້າເດີ່ ',
  registeredOn: 'ລົງທະບຽນແລ້ວວັນທີ',
  retry: 'ລອງໃໝ່',
  loadError: 'ບໍ່ສາມາດໂຫຼດສະຖານະການລົງທະບຽນໄດ້. ກະລຸນາລອງໃໝ່.',
  submitError: 'ບໍ່ສາມາດຢືນຢັນການລົງທະບຽນໄດ້. ກະລຸນາລອງໃໝ່.',
  networkError: 'ບໍ່ສາມາດເຊື່ອມຕໍ່ລະບົບໄດ້. ກະລຸນາກວດສອບອິນເຕີເນັດ ແລະ ລອງໃໝ່.',
  authError: 'ເຊສຊັນຂອງທ່ານບໍ່ຖືກຕ້ອງ ຫຼື ໝົດອາຍຸແລ້ວ. ກະລຸນາເປີດສູນຄົນຂັບຄືນໃໝ່ຈາກແອັບ LOCA ຄົນຂັບ.',
} satisfies Record<string, string>
